module.exports = __webpack_public_path__ + "static/media/pic-staedtequiz-1.db35af99.png";